import { render, staticRenderFns } from "./doorDetails.vue?vue&type=template&id=66ff4050&scoped=true&"
import script from "./doorDetails.vue?vue&type=script&lang=js&"
export * from "./doorDetails.vue?vue&type=script&lang=js&"
import style0 from "./doorDetails.vue?vue&type=style&index=0&id=66ff4050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff4050",
  null
  
)

export default component.exports